import React, { useEffect } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import useApis from "../../services/useAPI";
import { useAuth } from "../../components/AuthContext/AuthContext";
import { links } from "../../stories/Forms/fields";
import { createClinicalPatientUrl } from "../../utils/constants";
import logo from "../../assets/images/boots-myhealthchecked-logo.svg";
import img from "../../assets/images/notification.svg";
import PackageIcon from "../../assets/icons/Parcel.svg";
import PlusIcon from "../../assets/icons/Plus.svg";
import LoggedInLayout from "../../stories/LoggedInScreens/LoggedInLayout";
import VHConfirmationPopup from "../Modals/VHConfirmationPopup";
import PageLayout from "../../components/Layout/PageLayout";
import { useNavigate } from "react-router";

const NoPatientFoundCard = () => {
  const {
    callApi,
    resultPost,
    serverError,
  } = useApis();

  const auth = useAuth();
  const navigate = useNavigate();
  const selectedService = localStorage.getItem("selectedService");
  const isVhlogin = auth?.featureFlag;
  const clinicalDetails =
    JSON.parse(sessionStorage.getItem("clinicalPatientDetails")) ?? {};
  const createClinicalPatient = async () => {
    await callApi(
      clinicalDetails,
      createClinicalPatientUrl,
      "POST",
      {
        Authorization: `Bearer ${
          localStorage.getItem("access_token") || auth.accessToken
        }`,
        "Content-Type": "application/json",
      }
    );

  };
  const stages = ["patient-record","select-patient","patient-details","confirm-details","enter-barcode","appointment-confirmation"];
  
  useEffect(() => {
    if (!stages.includes(sessionStorage.getItem("allowedStage")) && auth?.featureFlag) {
      navigate("/patient-record");
    }
  },[sessionStorage.getItem("allowedStage"), auth?.featureFlag, navigate]);

  useEffect(() => {
    if (resultPost && !serverError) {
      auth?.allowStage("select-patient");
      navigate("/patient-record/clinical-details", {
        state: {
          data: clinicalDetails,
          user: resultPost?.user_info,
          isDuplicate: "true",
          id: resultPost.booking?.[0]?.phlebotomist_booking_id,
          isChildDisplay: true,
        },
        replace: true,
      });
    }
  }, [resultPost,serverError]);

  useEffect(() => {
    if (auth && selectedService === "healthCare") {
      auth.setTitle("Patient Record");
    } else {
      auth.setTitle("Clinical studies");
    }
  }, [auth?.title]);

  const handleBackClick = () => {
    navigate("/patient-record");
  };

  const oldContent = (
    <>
      <Card className="d-flex align-items-center text-center patient-record-card">
        {serverError && (
          <p className="server-error align-self-start mb-0">{serverError}</p>
        )}

        <Card.Body>
          <Card className="no-patient-inner-card">
            <Card.Body>
              <div className="no-patient-content d-flex flex-column">
                <span>No participant records found</span>
                <Button
                  variant="primary"
                  className="create-patient"
                  onClick={createClinicalPatient}
                >
                  Create participant
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Card.Body>
      </Card>
      <div className="d-flex flex-row-reverse back-btn-wrapper">
        <button className="btn-back" onClick={() => handleBackClick()}>
          Back
        </button>
      </div>
    </>
  );

  return (
    <LoggedInLayout
      buttonLabel={"Logout"}
      img={img}
      isActivation={false}
      links={links}
      logo={logo}
      pageTitle={auth.title}
      userInitials={auth.userInitials}
      isVhlogin={isVhlogin}
      vitalityLayout={isVhlogin}
    >
      {isVhlogin ? (
        <PageLayout heading="" onBack={handleBackClick}>
          <VHConfirmationPopup
            className="vh-no-patient-found"
            icon={PackageIcon}
            title="No participant record found"
            message={
              <>
                We couldn't find a participant matching those details.
                <br />
                For existing participants, please check your entry details and try again.
                <br />
                <br />
                <span className="vh-no-patient-found__hint">
                  For new participants, select + Create participant.
                </span>
              </>
            }
            primaryLabel="Create participant"
            primaryIcon={PlusIcon}
            onPrimaryClick={createClinicalPatient}
          >
            {serverError && <p className="server-error">{serverError}</p>}
          </VHConfirmationPopup>
        </PageLayout>
      ) : (
        oldContent
      )}
    </LoggedInLayout>
  );
};

export default NoPatientFoundCard;